import React from "react";
import { SelectList } from "web-ui";

import { getDuolingoTtsLanguages } from "../api/duolingoTts";
import styles from "../styles/LangPicker.module.scss";

export const LangPicker = ({
  selectedLanguage,
  onChange,
}: {
  selectedLanguage: string;
  onChange: (language: string) => void;
}) => {
  const [languages, setLanguages] = React.useState<string[]>([]);

  React.useEffect(() => {
    (async () => {
      setLanguages(await getDuolingoTtsLanguages());
    })();
  }, []);

  const items = languages.map(lang => ({ text: lang }));

  return (
    <div>
      <SelectList
        className={styles["dropdown-selector"]}
        items={items}
        onChange={e => onChange(languages[e.selectedIndices[0]] ?? "")}
        popoverPosition={{
          direction: "down",
          manualPositioning: true,
          style: {
            marginTop: 50,
            maxHeight: 426,
            position: "absolute",
          },
          zIndex: 100,
        }}
        selectedIndices={
          selectedLanguage ? [languages.indexOf(selectedLanguage)] : []
        }
        showSearch={true}
        text={selectedLanguage ? selectedLanguage : "languages"}
      />
    </div>
  );
};
